module.exports = __webpack_public_path__ + "static/media/fhtv_floating.4d454ac3.png";